import classes from '../../utils/classes';
import styles from './login-panel-header.module.scss'

export default function LoginPanelHeader() {
    const secondRowClasses = classes(styles.headerText, styles.second);
    return (
        <div className={styles.panelHeader}>
            <div className={classes(styles.headerText, styles.image)} style={{height: '30px'}}>

            </div>
            <div className={secondRowClasses}>ACCOUNT OF DEATH</div>
        </div>
    );
}
